import { useChatbotState } from './useChatbotState';

export const addChatbotStateOverrides = () => {
  window.chatbotSetState = useChatbotState.setState;
};
